import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class SuspendLineEquipService {
  listLineData: any;
  listLines:any;
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
     
   /**
   * Description: Método que llama el servicio web de crear el ticket de suspensión
   * Autor: Diego Diaz
   * @param jsonData json con todos los parámetros requeridos
   * @return Mensaje de confirmación del ticket
   */
  suspendLineEquipRequest(jsonData) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_SUSPEND_REQUEST, jsonData);
  }


  
 /**
   * Description: Método que llama el servicio web de obtener el imei marca y modelo de una linea
   * Autor: Diego Diaz
   * @param phone cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  getInfoLines(phone) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_IMEI_LINES, { "identificationValue": phone });
  }

  
  /**
   * Description: Método que llama el servicio web de obtener todas las lineas del usuario
   * Autor: Diego Diaz
   * @param documentId cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  getAllUserLines(customerAccountId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_ALL_USER_LINES, { "customerAccountId": customerAccountId });
  }

}
